import type { ListItemProps } from '@mui/material';
import MuIListItem from '@mui/material/ListItem';
import { forwardRef } from 'react';

const ListItem = forwardRef<HTMLLIElement, ListItemProps>((props, ref) => {
  return <MuIListItem ref={ref} {...props} />;
});
export default ListItem;
